
try {
(function($, win, doc, RAF) {

    var vk_domain = doc.location.host,
        $body = $('body');

    var phone = $('head > meta[name="phone"]').attr('content') || '+31 (0)6 25 14 06 28';

    var update_cart_cache = win.update_cart_cache;

    $body.on('click', 'a.shopnow', function(event) {
        event.preventDefault();
        var cartAtts = {
            popupSelector: '.shopnow-products',
            addToCartUrlPrefix: 'cart/add/',
            addToCartButtonValue: 'Toevoegen aan de winkelwagen',
            closeCartButtonValue: 'Sluiten',
            id: (this.id),
            urlJson: $(this).attr('data-title') + '?format=json',
            urlAjax: ($(this).attr('data-title').replace('.html', '.ajax')) + '',
            shopId: '242507',
            shopDomain: 'https://'+vk_domain+'/',
            shopDomainNormal: 'https://'+vk_domain+'/',
            shopDomainSecure: 'https://'+vk_domain+'/'
        };
        cartAtts.shopDomain = cartAtts.shopDomainSecure;
        cartAtts.urlJson = cartAtts.shopDomainSecure + cartAtts.urlJson;
        cartAtts.urlAjax = cartAtts.shopDomainSecure + cartAtts.urlAjax;
        shopnow_popupProductCart(cartAtts);
    });

    function shopnow_popupProductCart(cartAtts) {
        $(cartAtts.popupSelector).html('Laden...');
        $(cartAtts.popupSelector).fadeIn('fast');

        $.when($.get(cartAtts.urlJson), $.get(cartAtts.urlAjax)).then(function(res1, res2) {
            var data = res1[0],
                dataProduct = res2[0];
            var defaultCurrency = data.product.price.price_incl;
            defaultCurrency = defaultCurrency * 100;
            defaultCurrency = parseInt(defaultCurrency);
            var selectedCurrency = dataProduct.price.price_incl_money_without_currency;
            selectedCurrency = selectedCurrency.toString().replace(',', '').replace('.', '');
            selectedCurrency = parseInt(selectedCurrency);
            data.customPriceConversion = defaultCurrency / selectedCurrency;
            data.shop.settings.legal.uvpHTML = '<span class="uvp"> SRP </span>';
            var popupHtml = '';
            var productId = data.product.vid;
            var imgId = data.product.image;
            var imgUrlId = imgId.toString();
            while (imgUrlId.length < 9) {
                imgUrlId = '0' + imgUrlId;
            }
            var imgUrl = data.shop.domains.static + 'files/' + imgUrlId + '/200x200x2/image.jpg';
            var productTitle = data.product.fulltitle;
            var productUrl = data.product.url;
            var shopDomain = data.shop.domain;
            popupHtml += '<a href="#" class="close"><i class="fa fa-times" aria-hidden="true"></i></a>';
            popupHtml += '<div class="col-lg-4 usp-column popup-usp-column"><h3 style="font-size:18px;font-weight:bold;">Voordelen van <span style="color:#ec0826;font-weight:bold;">✪</span> Verkoop.com</h3><ul><li><i class="fa fa-check" aria-hidden="true"></i>GRATIS verzending in NL en BE vanaf € 20,-</li><li><i class="fa fa-check" aria-hidden="true"></i>Voor 17:00 uur besteld, dezelfde dag verzonden</li><li><i class="fa fa-check" aria-hidden="true"></i>Afrekenen in veilige omgeving</li><li><i class="fa fa-check" aria-hidden="true"></i>VRAGEN ? <strong style="font-weight:bold;font-size:inherit;">' + phone + '</strong></li></ul></div>';
            popupHtml += shopnow_getCartFormHTML(data, dataProduct, cartAtts);
            $popup = $(cartAtts.popupSelector);
            $popup.html(popupHtml);
            if (data.product.stock.available == false) {
                $.each(data.product.variants, function(index, value) {
                    if (this.stock.available == true) {
                        $('.popup-product-variants', $popup).val(index);
                        shopnow_updateForm(data, dataProduct, cartAtts, $(cartAtts.popupSelector + ' .popup-product-variants'));
                        return false;
                    }
                });
            }
            $('.popup-product-variants', $popup).on('change', function() {
                shopnow_updateForm(data, dataProduct, cartAtts, $(this));
            });
            $(cartAtts.popupSelector + ' .product-configure-custom .product-configure-custom-option').each(function() {
                $(this).find('input[type="checkbox"]').each(function() {
                    $(this).change(function() {
                        shopnow_updateForm(data, dataProduct, cartAtts, $(this));
                    });
                });
                $(this).find('input[type="radio"]').each(function() {
                    $(this).change(function() {
                        shopnow_updateForm(data, dataProduct, cartAtts, $(this));
                    });
                });
                $(this).find('select').each(function() {
                    $(this).change(function() {
                        shopnow_updateForm(data, dataProduct, cartAtts, $(this));
                    });
                });
            });

            $popup.on('click', 'a.add-to-cart', function(event) {
                $(cartAtts.popupSelector + ' .errorRow').remove();
                event.preventDefault();
                var ajaxUrl = $(cartAtts.popupSelector + ' .product_configure_form').attr('action');
                var formData = $(cartAtts.popupSelector + ' .product_configure_form').serializeObject();
                var loadUrl = ajaxUrl;
                var continueAjax = true;
                var errorHTML = '';
                if (dataProduct.stock.allow_outofstock_sale == true) {
                    continueAjax = true;
                } else {

                }
                if (continueAjax == true) {
                    shopnow_addToCart(loadUrl, formData, cartAtts);
                }
            });
            $popup.on('click', 'a.close,a.verder', function(event) {
                event.preventDefault();
                shopnow_clearSelf(cartAtts);
            });

            $body.data('shopnow', cartAtts);
            $body.on('click', shopnow_bodyclick);
            $(cartAtts.popupSelector).on('click', function(e) {
                e.stopPropagation();
            });
            // });
        }, function() {
            console.error('request failed');
        });
    }

    function shopnow_bodyclick(event) {
        var cartAtts = $body.data('shopnow');
        event.preventDefault();
        shopnow_clearSelf(cartAtts);
    };

    function shopnow_clearSelf(cartAtts) {
        $(cartAtts.popupSelector).fadeOut('fast');
        $(cartAtts.popupSelector).html('');

        $(cartAtts.popupSelector + ' a.close, ' + cartAtts.popupSelector + ' a.verder').off('click');
        $body.off('click', shopnow_bodyclick);
        $(cartAtts.popupSelector).off('click');
    }

    function fetch_cart_html(callback) {
        fetch('https://'+vk_domain+'/cart/', {
                credentials: 'include'
            }).then(function(response) {

                if (response.ok) {
                    response.text()
                        .then(function(text) {
                            callback(text);
                        })
                        .catch(function(err) {
                            console.error('[CART]', err);
                        });
                } else {
                    console.error('[CART]', 'invalid response', response.status, response.statusText);
                }

            }).catch(function(err) {
                console.error('[CART]', err);
            });
    }

    function shopnow_addToCart(loadUrl, formData, cartAtts) {
        if (window.location.protocol == "https:") {
            loadUrl = loadUrl.replace(cartAtts.shopDomainNormal, cartAtts.shopDomainSecure);
        }

        var url = new URL(loadUrl);
        Object.keys(formData).forEach(function(key) { url.searchParams.append(key, formData[key]); });

        function continue_cart() {

            fetch_cart_html(function(result) {

                var returnPage = $(result);

                var errors = returnPage.find('.messages .error');
                var info = returnPage.find('.messages .info');
                if (errors.length > 0) {
                    $(cartAtts.popupSelector + ' .product_configure_form .messages').remove();
                    $(cartAtts.popupSelector + ' a.close').after('<div class="col-xs-12 messages"><ul class="error">' + errors.html() + '</ul></div>');
                } else {
                    shopnow_updateHeaderCartHTML(returnPage);
                    var popupSuccessContent = '';
                    if (info.length > 0) {
                        popupSuccessContent += '<div class="text-center col-md-12 col-sm-12 paddingsm"><div class="messages"><ul class="info">' + info.html() + '</ul></div></div>';
                    }


                    popupSuccessContent += '<h3>Winkelwagen</h3><div class="view-cart"></div>';
                    $('.content').removeClass('col-md-9');
                    $('.productIMG').remove();
                    $(cartAtts.popupSelector + ' .content').html(popupSuccessContent);
                    var succesHTML = '';
                    succesHTML += '<div class="col-md-6"><img src="https://assets.webshopapp.com/amanja-bv/logo-in-popup.png?20180607114714" alt="Verkoop.com" width="200" /></div> <a href="https://'+vk_domain+'/cart/" class="btn btn-md btn-view checkout pull-right"><span>Naar de kassa</span></a> ';
                    succesHTML += ' <a href="#" class="btn btn-sm btn-default verder pull-right" title="Verder winkelen"><span>Verder winkelen</span></a> ';
                    $(cartAtts.popupSelector + ' .succesRow').html(succesHTML);
                    $(cartAtts.popupSelector + ' .succesRow .btn.verder').on('click', function(event) {
                        event.preventDefault();
                        shopnow_clearSelf(cartAtts);
                    });
                    $(cartAtts.popupSelector + ' .messages').remove();
                    shopnow_updatePopupCartHTML(returnPage);
                }
                $(this).remove();

                update_cart_cache();
            });
        }

        // apr-2018 optimization: post instead of load
        fetch(url, {
            credentials: 'include',
            redirect: 'manual'
        }).then(function(response) {
        //$.post(loadUrl, formData, function(result, s, req) {
            continue_cart();
        }).catch(function() {
            continue_cart();
        });
    }

    function shopnow_updateHeaderCartHTML(page) {
        var newCartContent = $(page).find('#cartContainer');
        $('#cartContainer a.cart').html(newCartContent.find('a.cart').html());
        $('#cartContainer .view-cart').html(newCartContent.find('.view-cart').html());
        if (typeof updateCartContainerTotalQuantity == 'function') {
            updateCartContainerTotalQuantity();
        }
    }

    function shopnow_updatePopupCartHTML(page) {
        var newCartContentPopup = $(page).find('#cartContainer');
        // Voeg een horiz lijn toe voor de totalen
        newCartContentPopup.find('.view-cart .total').before('<hr>');
        // Verwijder de checkout button
        newCartContentPopup.find('.view-cart .total .btn').remove();
        $('.shopnow-products .content .view-cart').html(newCartContentPopup.find('.view-cart').html());
    }

    function shopnow_getCartFormHTML(data, dataProduct, cartAtts) {
        var product = data.product;
        var shop = data.shop;
        var productId = data.product.vid;
        var imgId = data.product.image;
        var imgUrlId = imgId.toString();
        while (imgUrlId.length < 9) {
            imgUrlId = '0' + imgUrlId;
        }
        var imgUrl = data.shop.domains.static + 'files/' + imgUrlId + '/200x200x2/image.jpg';
        var html = '';
        var actionUrlBase = cartAtts.shopDomainNormal;
        if (window.location.protocol == "https:") {
            actionUrlBase = actionUrlBase.replace(cartAtts.shopDomainNormal, cartAtts.shopDomainSecure);
        }
        html += '<form action="' + actionUrlBase + cartAtts.addToCartUrlPrefix + product.vid + '/" class="product_configure_form" method="post">';
        html += '<div class="col-md-8 paddinground content popup-content">';
        html += '<div class="col-md-12 content-info">';
        html += '<div class="title">' + data.product.fulltitle + '</div>';
        html += '<div class="col-md-4 text-center productIMG paddingtopbot"><img src="' + imgUrl + '" alt="' + data.product.fulltitle + '" title="' + data.product.fulltitle + '" /></div>';

        html += '<div class="col-md-8">';
        html += '<div class="description paddingsm">' + data.product.description + '<br /><a href="' + actionUrlBase + data.product.url + '" class="btn btn-xxs btn-default">Meer informatie</a></div>';

        html += '<div class="col-md-12 content-cart paddingsm">';
        html += '<div class="product-configure tui">';
        html += '<input name="bundle_id" id="product_configure_bundle_id" value="" type="hidden">';
        html += shopnow_getCartVariantsHTML(data, dataProduct);
        html += shopnow_getCartCustomOptionsHTML(data, dataProduct);
        html += '</div>';
        html += shopnow_getCartPricesHTML(data, dataProduct);
        html += shopnow_getCartQuantityHTML(data, dataProduct);
        if (product.stock.available == true) {
            html += '<div class="col-md-3 nopadding pull-left"><a id="addtocart_' + product.id + '" href="javascript:;" data-id="' + product.vid + '" class="btn btn-md btn-icon btn-view add-to-cart pull-left" title="In winkelwagen">';
            html += '<span>In winkelwagen</span> <i class="fa fa-shopping-cart" aria-hidden="true"></i>';
            html += '</a>';
            html += '<span class="out-of-stock" style="display: none;">Niet op voorraad. Bel voor de levertijd: <div style="font-size:16px;"><strong>' + phone + '</strong></div></span></div>';
        } else {
            html += '<div class="col-md-3 nopadding pull-left"><a id="addtocart_' + product.id + '" href="javascript:;" data-id="' + product.vid + '" class="btn btn-md btn-icon btn-view add-to-cart pull-left" title="In winkelwagen" style="display: none;">';
            html += '<span>In winkelwagen</span> <i class="fa fa-shopping-cart" aria-hidden="true"></i>';
            html += '</a>';
            html += '<span class="out-of-stock">Niet op voorraad. Bel voor de levertijd: <div style="font-size:16px;"><strong>' + phone + '</strong></div></span></div>';
        };
        html += '</div></div></div>';
        html += '</form>';
        return html;
    }

    function shopnow_getCartVariantsHTML(data, dataProduct) {
        var product = data.product;
        var shop = data.shop;
        var html = '';
        html += '<div class="product-info-options product-configure-options tui">';
        if (ObjectLength(product.variants) > 1) {
            html += '<select class="popup-product-variants">';
            $.each(product.variants, function(index, value) {
                if (this.stock.available == true) {
                    html += '<option value="' + index + '">' + value.title + '</option>';
                } else {
                    html += '<option value="' + index + '" class="out" disabled>' + value.title + '</option>';
                }
            });
            html += '</select>';
        } else {
            html += product.variant;
        }
        html += '</div>';
        return html;
    }

    function shopnow_getCartCustomOptionsHTML(data, dataProduct) {
        var product = data.product;
        var shop = data.shop;
        var html = '';
        if (ObjectLength(product.custom) >= 1) {
            html += '<div class="product-info-custom product-configure-custom tui">';
            $.each(product.custom, function(index, value) {
                html += '<div class="product-configure-custom-option ' + index + ' ' + value.type + '">';
                var required = '';
                if (value.required == true) {
                    required = ' <em>*</em>';
                }
                switch (value.type) {
                    case 'text':
                        html += '<label for="product_configure_custom_' + index + '">' + value.title + ':' + required + '</label>';
                        html += '<input type="text" name="custom[' + index + ']" id="product_configure_custom_' + index + '" />';
                        break;
                    case 'textarea':
                        html += '<label for="product_configure_custom_' + index + '">' + value.title + ':' + required + '</label>';
                        html += '<textarea type="text" name="custom[' + index + ']" id="product_configure_custom_' + index + '" />';
                        break;
                    case 'multipleselect':
                        html += '<label for="product_configure_custom_' + index + '">' + value.title + ':' + required + '</label>';
                        html += '<select name="custom[' + index + '][]" id="product_configure_custom_' + index + '" multiple="multiple">';
                        $.each(value.values, function(childindex, childvalue) {
                            var price = shopnow_formatOptionPrice(childvalue, data);
                            html += '<option value="' + childindex + '" data-price="' + childvalue.price + '">' + childvalue.title + price + '</option>';
                        });
                        html += '</select>';
                        break;
                    case 'select':
                        html += '<label for="product_configure_custom_' + index + '">' + value.title + ':' + required + '</label>';
                        html += '<select name="custom[' + index + ']" id="product_configure_custom_' + index + '">';
                        html += '<option value="" disabled="disabled" selected="selected">Maak een keuze...</option>';
                        $.each(value.values, function(childindex, childvalue) {
                            var price = shopnow_formatOptionPrice(childvalue, data);
                            html += '<option value="' + childindex + '" data-price="' + childvalue.price + '">' + childvalue.title + price + '</option>';
                        });
                        html += '</select>';
                        break;
                    case 'checkbox':
                        html += '<label>' + value.title + ':' + required + '</label>';
                        $.each(value.values, function(childindex, childvalue) {
                            var price = shopnow_formatOptionPrice(childvalue, data);
                            html += '<div class="product-configure-custom-option-item">';
                            html += '<input type="checkbox" name="custom[' + index + '][]" id="product_configure_custom_' + index + '_' + childindex + '" class="product_configure_custom_' + index + '" data-price="' + childvalue.price + '" value="' + childindex + '" />';
                            html += '<label for="product_configure_custom_' + index + '_' + childindex + '">' + childvalue.title + price + '</label>';
                            html += '<div class="product-configure-clear"></div>';
                            html += '</div>';
                        });
                        break;
                    case 'radio':
                        html += '<label>' + value.title + ':' + required + '</label>';
                        $.each(value.values, function(childindex, childvalue) {
                            var price = shopnow_formatOptionPrice(childvalue, data);
                            html += '<div class="product-configure-custom-option-item">';
                            html += '<input type="radio" name="custom[' + index + ']" id="product_configure_custom_' + index + '_' + childindex + '" class="product_configure_custom_' + index + '" data-price="' + childvalue.price + '" value="' + childindex + '" />';
                            html += '<label for="product_configure_custom_' + index + '_' + childindex + '">' + childvalue.title + price + '</label>';
                            html += '<div class="product-configure-clear"></div>';
                            html += '</div>';
                        });
                        break;
                    case 'date':
                        html += '<label for="product_configure_custom_' + index + '">' + value.title + ':' + required + '</label>';
                        html += '<div class="product-configure-custom-option-item">';
                        html += '<div class="product-configure-custom-option-date">';
                        html += '<select name="custom[' + index + '][day]" class="product-configure-custom-option-date-day">';
                        for (var i = 0; i <= 31; i++) {
                            if (i == 0) {
                                html += '<option value="">Dag</option>';
                            } else {
                                html += '<option value="' + i + '">' + i + '</option>';
                            }
                        }
                        html += '</select>';
                        html += '<select name="custom[' + index + '][month]" class="product-configure-custom-option-date-month">';
                        var monthNames = new Array('', 'Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December');
                        for (var i = 0; i <= 12; i++) {
                            if (i == 0) {
                                html += '<option value="">Maand</option>';
                            } else {
                                html += '<option value="' + i + '">' + monthNames[i] + '</option>';
                            }
                        }
                        html += '</select>';
                        html += '<select name="custom[' + index + '][year]" class="product-configure-custom-option-date-year">';
                        var currentYear = new Date().getFullYear();
                        for (var i = (currentYear + 10); i >= 1900; i--) {
                            if (i == (currentYear + 10)) {
                                html += '<option value="">Jaar</option>';
                            } else {
                                html += '<option value="' + i + '">' + i + '</option>';
                            }
                        }
                        html += '</select>';
                        html += '</div>';
                        html += '</div>';
                        break;
                }
                html += '<div class="product-configure-clear"></div>';
                html += '</div>';
            });
            html += '</div>';
        }
        return html;
    }

    function shopnow_getCartQuantityHTML(data, dataProduct) {
        var product = data.product;
        var shop = data.shop;
        var html = '';
        if (product.stock.available == true) {
            html += '</div></div><div class="col-md-12 col-sm-12 succesRow paddingtop"><div class="col-md-6 paddingtop popup-logo"><img src="https://assets.webshopapp.com/amanja-bv/logo-in-popup.png?20180607114714" alt="Verkoop.com" width="200" /></div><div class="quantity col-md-3 paddingsm">';
        } else {
            html += '</div></div><div class="col-md-12 col-sm-12 succesRow paddingtop"><div class="col-md-6 paddingtop popup-logo"><img src="https://assets.webshopapp.com/amanja-bv/logo-in-popup.png?20180607114714" alt="Verkoop.com" width="200" /></div><div class="quantity col-md-3 paddingsm" style="display: none;">';
        }
        html += '<div class="pricing col-xs-8">';
        if (dataProduct.price.price_old) {
            html += '<p class="price price-offer">';
            html += '<span class="border">';
            if (data.shop.b2b == true) {
                html += '<span class="price-old">' + dataProduct.price.price_old_excl_money;
                if (shop.settings.legal.mode == 'strict') {
                    html += ' ' + data.shop.settings.legal.uvpHTML
                };
                html += '</span>';
                html += '<span class="price-new">' + dataProduct.price.price_excl_money + '</span>';
            } else {
                html += '<span class="price-old">' + dataProduct.price.price_old_incl_money;
                if (shop.settings.legal.mode == 'strict') {
                    html += ' ' + data.shop.settings.legal.uvpHTML
                };
                html += '</span>';
                html += '<span class="price-new">' + dataProduct.price.price_incl_money + '</span>';
            }
            html += '</span>';
            html += '</p>';
        } else {
            html += '<p class="price">';
            if (data.shop.b2b == true) {
                html += dataProduct.price.price_excl_money;
            } else {
                html += dataProduct.price.price_incl_money;
            }
            html += '</p>';
        }
        html += '<div class="price-tax">';
        if (data.shop.b2b == true) {
            html += 'Excl. btw';
        } else {
            html += 'Incl. btw';
        }
        html += '</div></div>';
        html += '<input type="text" name="quantity" class="form-control input-number" value="' + product.quantity + '" />';
        html += '</div>';
        return html;
    }

    function shopnow_getCartPricesHTML(data, dataProduct) {
        var product = data.product;
        var shop = data.shop;
        var html = '';

        html += '<div class="price-tax">';
        if (data.shop.b2b == true) {} else {}
        if (shop.settings.legal.mode == 'strict') {
            html += '<br /> Excl. <a href = "https://'+vk_domain+'/service/shipping-returns/" target = "_blank" rel=noopener  >  Shipping costs  </a> ';
        }
        html += '</div>';
        html += '</div></div></div>';
        return html;
    }

    function shopnow_formatOptionPrice(value, data) {
        var price = '';
        if (value.percentage == true) {
            if (value.price > 0) {
                price = ' (+' + value.price + '%)';
            } else if (value.price < 0) {
                price = ' (' + value.price + '%)';
            }
        } else {
            if (value.price > 0) {
                price = ' (+' + shopnow_formatPrice(value.price, data) + ')';
            } else if (value.price < 0) {
                price = ' (' + shopnow_formatPrice(value.price, data) + ')';
            }
        }
        return price;
    }

    function shopnow_formatPrice(value, data, convert) {
        convert = typeof convert !== 'undefined' ? convert : true;
        var product = data.product;
        var shop = data.shop;
        if (convert == true) {
            value = shopnow_convertCurrency(data, value);
        }
        return data.shop.currency2.symbol + '' + value.formatMoney(2, ',', '.');
    }

    function shopnow_convertCurrency(data, value) {
        if (data.shop.currency === data.shop.base_currency) return value;
        if (!isNaN(data.customPriceConversion - 0) && data.customPriceConversion != null) {
            value = (value / data.customPriceConversion);
        }
        return value;
    }


    function shopnow_updateForm(data, dataProduct, cartAtts, changeObj) {
        var product = data.product;
        var shop = data.shop;
        var currentVariant = $(cartAtts.popupSelector + ' .popup-product-variants');
        if (currentVariant.length > 0) {
            if (data.shop.b2b == true) {
                var oldPrice = data.product.variants[currentVariant.val()].price.price_old_excl;
                var currentPrice = data.product.variants[currentVariant.val()].price.price_excl;
            } else {
                var oldPrice = dataProduct.variants[currentVariant.val()].price.price_old_incl;
                var currentPrice = dataProduct.variants[currentVariant.val()].price.price_incl;
            }
        } else {
            if (data.shop.b2b == true) {
                var oldPrice = dataProduct.price.price_old_excl;
                var currentPrice = dataProduct.price.price_excl;
            } else {
                var oldPrice = dataProduct.price.price_old_incl;
                var currentPrice = dataProduct.price.price_incl;
            }
        }
        if (oldPrice != false) {
            oldPrice = shopnow_convertCurrency(data, oldPrice);
        }
        currentPrice = shopnow_convertCurrency(data, currentPrice);
        var optionPriceTotal = 0;
        var addValue = 0;
        $(cartAtts.popupSelector + ' .product-configure-custom .product-configure-custom-option').each(function() {
            $(this).find('input[type="checkbox"]:checked').each(function() {
                addValue = shopnow_getPriceFromText(data, $(this).parent().children('label[for="' + $(this).attr('id') + '"]').html());
                if (!isNaN(addValue) && addValue != null) {
                    optionPriceTotal += addValue;
                }
            });
            $(this).find('input[type="radio"]:checked').each(function() {
                addValue = shopnow_getPriceFromText(data, $(this).parent().children('label[for="' + $(this).attr('id') + '"]').html());
                if (!isNaN(addValue) && addValue != null) {
                    optionPriceTotal += addValue;
                }
            });
            $(this).find('select option:selected').each(function() {
                addValue = shopnow_getPriceFromText(data, $(this).html());
                if (!isNaN(addValue) && addValue != null) {
                    optionPriceTotal += addValue;
                }
            });
        })
        if (oldPrice != false) {
            oldPrice = shopnow_formatPrice(oldPrice + optionPriceTotal, data, false);
            if (shop.settings.legal.mode == 'strict') {
                oldPrice += ' ' + shop.settings.legal.uvpHTML
            };
        }
        currentPrice = shopnow_formatPrice(currentPrice + optionPriceTotal, data, false);
        if (currentVariant.length > 0) {
            $(cartAtts.popupSelector + ' a.add-to-cart').attr('data-id', currentVariant.val());
            $(cartAtts.popupSelector + ' .product_configure_form').attr('action', shop.domains.normal + cartAtts.addToCartUrlPrefix + currentVariant.val() + '/');
        }
        if (oldPrice != false) {
            $(cartAtts.popupSelector + ' .pricing .price').html('<span class="border"><span class="price-old">' + oldPrice + '</span><span class="price-new">' + currentPrice + '</span></span>');
            $(cartAtts.popupSelector + ' .pricing .price').addClass('price-offer');
        } else {
            $(cartAtts.popupSelector + ' .pricing .price').html(currentPrice);
            $(cartAtts.popupSelector + ' .pricing .price').removeClass('price-offer');
        }
        var stock = false;
        if (currentVariant.length > 0) {
            if (data.product.variants[currentVariant.val()].stock.available == true) {
                stock = true;
            }
        } else {
            if (data.product.stock.available == true) {
                stock = true;
            }
        }
        if (stock == true) {
            $(cartAtts.popupSelector + ' .quantity').fadeIn('fast');
            $(cartAtts.popupSelector + ' a.add-to-cart').fadeIn('fast');
            $(cartAtts.popupSelector + ' .out-of-stock').fadeOut('fast');
        } else {
            $(cartAtts.popupSelector + ' .quantity').fadeOut('fast');
            $(cartAtts.popupSelector + ' a.add-to-cart').fadeOut('fast');
            $(cartAtts.popupSelector + ' .out-of-stock').fadeIn('fast');
        }
    }

    function shopnow_getPriceFromText(data, val) {
        if (val.search(data.shop.currency2.symbol) == -1 || val.lastIndexOf(data.shop.currency2.symbol) < 0 || val.indexOf(data.shop.currency2.symbol) < 0) {
            return null;
        }
        val = val.substring(val.lastIndexOf(data.shop.currency2.symbol) + 1);
        val = val.replace(/[^0-9-]/g, '');
        valInt = val.substring(0, val.length - 2);
        valDecimals = val.substring(val.length - 2);
        val = valInt + '.' + valDecimals;
        val = parseFloat(val);
        return val;
    }
    
    if (typeof ObjectLength != 'function') {
        function ObjectLength(object) {
            var length = 0;
            for (var key in object) {
                if (object.hasOwnProperty(key)) {
                    ++length;
                }
            }
            return length;
        };
    }
    if ($.fn.serializeObject == undefined) {
        $.fn.serializeObject = function() {
            var o = {};
            var a = this.serializeArray();
            $.each(a, function() {
                if (o[this.name]) {
                    if (!o[this.name].push) {
                        o[this.name] = [o[this.name]];
                    }
                    o[this.name].push(this.value || '');
                } else {
                    o[this.name] = this.value || '';
                }
            });
            return o;
        };
    };

    /**
        product-popup-js.rain
     */
    $body.on('click', 'a.popup, input.popup', function(event) {
        event.preventDefault();
        $(this).closest('.product').find('.messages').remove();
        var popupAttsAjax = {
            this: this,
            popupSelector: '.popup-products',
            title: $(this).attr('data-title'),
            image: $('<div>').append($(this).closest('.product').find('img.featured').clone()).html(),
            id: (this.id),
            shopId: '242507',
            shopDomain: 'https://'+vk_domain+'/',
            shopDomainNormal: 'https://'+vk_domain+'/',
            shopDomainSecure: 'https://'+vk_domain+'/',
            shopB2B: ''
        };
        if (window.location.protocol == "https:") {
            popupAttsAjax.shopDomain = popupAttsAjax.shopDomainSecure;
        } else {
            popupAttsAjax.shopDomain = popupAttsAjax.shopDomainNormal;
        }
        productPopup_init(popupAttsAjax);
    });

    function productPopup_init(popupAttsAjax) {
        var product = $(popupAttsAjax.this).closest('.product');
        var dataStock_allow_outofstock_sale = Boolean(product.data('stock-allow_outofstock_sale'));
        var dataStock_level = product.data('stock-level');
        var containerForm = $(popupAttsAjax.this).closest('.product_configure_form');
        var ajaxAddToCartUrl = containerForm.attr('action');
        var formData = containerForm.serializeObject();
        if (typeof formData.quantity == 'undefined') {
            formData.quantity = "1";
        }
        var loadUrl = ajaxAddToCartUrl;
        var continueAjax = true;
        var errorHTML = '';
        if (dataStock_allow_outofstock_sale == true) {
            continueAjax = true;
        } else {
            if (parseInt(formData.quantity) <= dataStock_level) {
                continueAjax = true;
            } else {
                continueAjax = true;
            }
        }
        if (continueAjax == true) {
            $(popupAttsAjax.popupSelector).html('Laden...');
            $(popupAttsAjax.popupSelector).fadeIn('fast');
            var popupHtml = '';
            popupHtml += '<a href="#" class="close"><span class="fa fa-times"></span></a>';
            if (window.location.protocol == "https:") {
                loadUrl = loadUrl.replace(popupAttsAjax.shopDomain, popupAttsAjax.shopDomainSecure);
            }

            // apr-2018 optimization: post instead of load

            function continue_cart() {
                fetch_cart_html(function(result) {

                    var returnPage = $(result);
                    var errors = returnPage.find('.messages .error');
                    var info = returnPage.find('.messages .info');
                    if (status == 'error') {
                        $('.popup-products').html(xhr.status + " " + xhr.statusText);
                        setTimeout(function() {
                            $(popupAttsAjax.popupSelector).fadeOut('fast');
                            $(popupAttsAjax.popupSelector).html('');
                        }, 2000);
                    } else {
                        if (errors.length > 0) {
                            popupHtml += '<div class="messages"><ul class="error">' + errors.html() + '</ul></div>';
                            $('.popup-products').html(popupHtml);
                            setTimeout(function() {
                                $(popupAttsAjax.popupSelector).fadeOut('fast');
                                $(popupAttsAjax.popupSelector).html('');
                            }, 2000);
                        } else {
                            var productTitle = '';
                            if (typeof popupAttsAjax.title !== 'undefined') {
                                var productTitle = popupAttsAjax.title;
                            }
                            popupHtml += '<div class="col-md-12 text-center"><div class="title">' + productTitle + '</div></div>';
                            if (typeof popupAttsAjax.image != 'undefined') {
                                popupHtml += '<div class="text-center col-md-12 col-sm-12 paddingsm">' + popupAttsAjax.image + '</div>';
                            }
                            if (info.length > 0) {
                                popupHtml += '<div class="text-center col-md-12 col-sm-12 paddingsm"><div class="messages"><ul class="info">' + info.html() + '</ul></div></div>';
                            }
                            popupHtml += '<div class="text-center col-md-12 col-sm-12 paddingsm">Dit product is toegevoegd aan de winkelwagen</div>';
                            popupHtml += '<div class="buttons text-center paddingsm">';
                            popupHtml += '<a href="#" class="btn btn-md btn-view btn-outline verder">Verder winkelen</a>';
                            popupHtml += '<a href="/cart/" class="btn btn-md btn-view checkout">Afrekenen</a>';
                            popupHtml += '</div>';
                            $('.popup-products').html(popupHtml);
                            $body.on('click', popupAttsAjax.popupSelector + ' a.close, ' + popupAttsAjax.popupSelector + ' a.verder', function(event) {
                                event.preventDefault();
                                $(popupAttsAjax.popupSelector).fadeOut('fast');
                                $(popupAttsAjax.popupSelector).html('');
                            });

                            var newCartContent = $(returnPage).find('#cartContainer');
                            $('#cartContainer a.cart').html(newCartContent.find('a.cart').html());
                            $('#cartContainer .view-cart').html(newCartContent.find('.view-cart').html());
                        }
                    }
                    $(this).remove();

                    update_cart_cache();
                });
            }

            var url = new URL(loadUrl);
            Object.keys(formData).forEach(function(key) {
                url.searchParams.append(key, formData[key]);
            });

            // apr-2018 optimization: post instead of load
            fetch(url, {
                credentials: 'include'
            }).then(function(response) {
                continue_cart();
            }).catch(function() {
                continue_cart();
            });

        }
    };

    function productPopup_updateHeaderCartHTML(page) {
        var newCartContent = $(page).find('#cartContainer');
        $('#cartContainer a.cart').html(newCartContent.find('a.cart').html());
        $('#cartContainer .view-cart').html(newCartContent.find('.view-cart').html());
        if (typeof updateCartContainerTotalQuantity == 'function') {
            updateCartContainerTotalQuantity();
        }
    }
    if ($.fn.serializeObject == undefined) {
        $.fn.serializeObject = function() {
            var o = {};
            var a = this.serializeArray();
            $.each(a, function() {
                if (o[this.name]) {
                    if (!o[this.name].push) {
                        o[this.name] = [o[this.name]];
                    }
                    o[this.name].push(this.value || '');
                } else {
                    o[this.name] = this.value || '';
                }
            });
            return o;
        };
    };

})(jQuery, window, document, window.RAF);
} catch(e){_st_catch(e)}
